import magicStyles from './relevant-information.magic.css.js';
import script from './relevant-information.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"relevant-information"},[_c('magic-ui-text',{staticClass:"relevant-information__text",attrs:{"tag":"h1","part":"text","content":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"relevant-information__descriptions",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('div',{staticClass:"relevant-information__buttons"},[_c('magic-ui-button',{attrs:{"button":"","wide":"","large":"","hollow":"","no-margin":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('pagcor.relevant-information-modal.exit'))},on:{"click":_vm.closeTab}}),_vm._v(" "),_c('magic-ui-button',{attrs:{"button":"","wide":"","large":"","no-margin":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('pagcor.relevant-information-modal.proceed'))},on:{"click":_vm.closeModal}})],1),_vm._v(" "),_c('div',{staticClass:"relevant-information__notice"},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"alert-triangle","part":"icon"}}),_vm._v(" "),_c('p',{staticClass:"relevant-information__notice-text",domProps:{"innerHTML":_vm._s(_vm.$t('pagcor.relevant-information-modal.alert'))}})],1),_vm._v(" "),_c('div',{staticClass:"relevant-information__image"},[_c('magic-ui-icon',{staticClass:"icon icon--logo",attrs:{"name":"pagcor-logo","part":"icon"}}),_vm._v(" "),_c('magic-ui-icon',{staticClass:"icon icon--min-age",attrs:{"name":"pagcor-min-age","part":"icon"}})],1)],1):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f77cc594_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-f77cc594";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
